import n from "react";
import s from "prop-types";
import y from "dayjs";
import { range as g, chunk as u, get as d } from "lodash";
import { a as m, m as p } from "./propTypes-DVvgo52A.es.js";
import { a as i, u as f } from "./utils-B8CGXZ5v.es.js";
import { A as D } from "./ArrowWrapper-CLLRWgcz.es.js";
import { D as M } from "./DateLabel-DaFJ1MkU.es.js";
import { C as _ } from "./CalendarUnitButton-Ch_cIohU.es.js";
import './MonthPicker.css';const v = "MonthPicker-module__row___F1B2t", C = "MonthPicker-module__monthContainer___8DpgN", H = "MonthPicker-module__monthDaysContainer___voF8I", l = {
  row: v,
  monthContainer: C,
  monthDaysContainer: H
};
class h extends n.Component {
  static initialYear(t, a) {
    return t && t.year || a && a.year || y().year();
  }
  constructor(t) {
    super(t);
    const a = h.initialYear(t.start, t.end);
    this.state = { year: a, hoveredMonth: null };
  }
  UNSAFE_componentWillReceiveProps(t) {
    t.start && t.start.year !== (this.props.start || {}).year && this.setState({ year: t.start.year }), t.end && t.end.year !== (this.props.end || {}).year && this.setState({ year: t.end.year });
  }
  getHighlightedMonths() {
    const { year: t } = this.state, a = this.state.hoveredMonth && {
      year: t,
      month: this.state.hoveredMonth
    }, { start: o } = this.props;
    if (o && !this.props.rangeMode) {
      const r = o.year === t ? o.month : -1;
      return { startHighlight: r, endHighlight: r };
    }
    const e = this.props.end || a;
    return !o || !e || !i(o, e) || !i(o, { year: t, month: 12 }) || !i({ year: t, month: 1 }, e) ? null : {
      startHighlight: o.year === t ? o.month : -1,
      endHighlight: e.year === t ? e.month : 13
    };
  }
  handleClick(t) {
    const a = { month: t, year: this.state.year };
    f(
      a,
      this.props.start,
      this.props.onSetStart,
      this.props.end,
      this.props.onSetEnd,
      this.props.focused,
      this.props.rangeMode
    );
  }
  handleHover(t) {
    this.setState({ hoveredMonth: t });
  }
  render() {
    const t = this.getHighlightedMonths(), a = g(12).map(
      (e) => new Date(2e3, e, 15).toLocaleString(void 0, { month: "short" })
    ), o = u(
      a.map((e, r) => ({
        text: e,
        disabled: !i(
          ...[
            this.props.minDate,
            { month: r + 1, year: this.state.year },
            this.props.maxDate
          ].filter((c) => c !== null)
        ),
        highlight: !!t && t.startHighlight <= r + 1 && r + 1 <= t.endHighlight,
        startPoint: d(t, "startHighlight") === r + 1,
        endPoint: d(t, "endHighlight") === r + 1,
        onClick: () => this.handleClick(r + 1),
        onMouseOver: () => this.handleHover(r + 1),
        onMouseOut: () => this.handleHover(null)
      })),
      3
    );
    return /* @__PURE__ */ n.createElement(
      D,
      {
        onBack: () => this.setState(({ year: e }) => ({ year: e - 1 })),
        hideBack: !!this.props.minDate && this.state.year <= this.props.minDate.year,
        onForward: () => this.setState(({ year: e }) => ({ year: e + 1 })),
        hideForward: !!this.props.maxDate && this.state.year >= this.props.maxDate.year,
        rangeMode: this.props.rangeMode
      },
      /* @__PURE__ */ n.createElement("div", { className: l.monthContainer }, /* @__PURE__ */ n.createElement(M, { year: this.state.year }), /* @__PURE__ */ n.createElement("div", { className: l.monthDaysContainer }, o.map((e) => /* @__PURE__ */ n.createElement("div", { className: l.row, key: e[0].text }, e.map((r) => /* @__PURE__ */ n.createElement(
        _,
        {
          unit: "month",
          key: r.text,
          rangeMode: this.props.rangeMode,
          ...r
        }
      ))))))
    );
  }
}
h.propTypes = {
  focused: s.oneOf(["start", "end"]),
  start: p,
  end: p,
  onSetStart: s.func.isRequired,
  onSetEnd: s.func.isRequired,
  minDate: m,
  maxDate: m,
  rangeMode: s.bool.isRequired
};
h.defaultProps = {
  start: null,
  end: null,
  focused: null,
  minDate: null,
  maxDate: null
};
export {
  h as M
};
